import React from 'react'
import { Col, DatePicker, Row } from 'antd'
import { useDesignSubmittalLogContext } from '../../../../../DesignSubmittalLogContext'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import CIMSSelect from 'components/CIMSSelect'
import CIMSComment from 'components/CIMSComment'
import { useGenericComment } from 'components/CIMSComment/hooks/useGenericComment'
const help = HelpMessage.DesignSubmittals.Log

export const RouterReview: React.FC = () => {
  const {
    selectOptions: { disciplinesOptions, actionsOptions },
  } = useDesignSubmittalLogContext()
  return (
    <>
      <Row>
        <Col xs={24}>
          <CIMSFormItem
            name="disciplineIds"
            label="Discipline(s)"
            requiredMessage="Please select at least one discipline"
            help={help.Disciplines}
          >
            <CIMSSelect simple mode="multiple" options={disciplinesOptions} />
          </CIMSFormItem>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <CIMSFormItem
            name="actionIds"
            label="Action(s)"
            requiredMessage="Please select at least one action"
            help={help.Actions}
          >
            <CIMSSelect simple mode="multiple" options={actionsOptions} />
          </CIMSFormItem>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <CIMSFormItem
            name="contractDueDate"
            label="Contract Due Date"
            requiredMessage="Please select a contract due date"
            help={help.ContractDueDate}
          >
            <DatePicker allowClear />
          </CIMSFormItem>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <CIMSFormItem
            {...useGenericComment({ required: { action: 'review' } })}
          >
            <CIMSComment />
          </CIMSFormItem>
        </Col>
      </Row>
    </>
  )
}
